// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"213197a5","973":"fede6e8e"}[chunkId] + ".chunk.js";
};